export default __webpack_public_path__ + "static/media/cabify.b43cc967.svg";